import React, { ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { JsonLd } from '../../../JsonLd';
import CONFIG from '../../../../config';
import { CurrentItemBreadcrumbsProps } from './types';
import { SCHEMA_CONTEXT, SchemaOrgType } from '../../../../seo.constants';

const getListItem = (index: number, name: ReactNode, item: string) => ({
  '@type': SchemaOrgType.ListItem,
  position: index + 1,
  name,
  item
});

export const BreadcrumbSchema: React.FC<CurrentItemBreadcrumbsProps> = ({
  breadcrumbs = [],
  title
}) => {
  const { i18n } = useTranslation();
  const { asPath, pathname } = useRouter();

  const origin = useMemo(() => {
    const langPrefix = i18n.language === 'ru' ? 'ru.' : '';
    return `${CONFIG.protocol}://${langPrefix}${CONFIG.host}`;
  }, [i18n.language]);

  const currPath = origin + asPath;

  const breadcrumbJsonLd = useMemo(() => {
    const breadcrumbsList =
      breadcrumbs?.map(({ path, name }, index) =>
        getListItem(index, name, path ? origin + path : currPath)
      ) || [];

    const itemListElement =
      pathname === '/items/[item]'
        ? [
            ...breadcrumbsList,
            getListItem((breadcrumbs ?? []).length, title || '', currPath)
          ]
        : breadcrumbsList;

    return {
      '@id': currPath,
      '@context': SCHEMA_CONTEXT,
      '@type': SchemaOrgType.BreadcrumbList,
      itemListElement
    };
  }, [breadcrumbs, currPath, pathname, title]);

  return <JsonLd data={breadcrumbJsonLd} />;
};
